export const mockStartSessionParams = {
    userInfo: {
        id: 'TestMockUser',
        firstName: 'D0123456, N5',
        controlOnlyInfo: {
            nc: 'D0123456',
            c: 'c',
            to: 'to',
            e: 'flv',
            t: 'N42',
            ca: 'mban',
            so: '3607',
            fd: 'FDBM01',
            tm: 'TMD01',
            cd: '596',
            td: 'A',
            u: 'U7130'
        },
    },
    assignmentInfo: {
        account: '12345',
        token: '1234',
        group: 'group1',
        subgroup: 'subgroup1'
    }
};